/*
 * Checkout Flow — <cf-configurator> : recommandation déterministe (aucune API, aucune IA).
 * Règles documentées dans docs/03-administration.md, section « Configurateur ».
 * La recommandation n'est pas un abonnement : elle est transmise au formulaire de devis.
 */
(() => {
  const start = () => {
    const CF = window.CF;
    if (!CF || customElements.get('cf-configurator')) return;

    function recommend(a) {
      const why = [];
      let rec = '';
      const needs = a.needs || [];
      const prov = a.provider && a.provider !== 'prov_none' ? a.provider : '';
      switch (a.service) {
        case 'sumup':
          if (a.store === 'store_none') { rec = 'sumup_new_store'; why.push('sumup_new_store', 'sumup_base'); }
          else if (a.store === 'store_other') { rec = 'sumup_other_platform'; why.push('sumup_other_platform'); }
          else { rec = needs.includes('need_shop') ? 'sumup_omni' : 'sumup_online'; why.push('sumup_base'); }
          if (needs.includes('need_shop')) why.push('shop');
          if (needs.includes('need_intl')) why.push('intl');
          if (needs.includes('need_sumup_account')) why.push('has_account');
          if (prov) why.push('keep_provider');
          if (a.volume === 'vol_3') why.push('volume_high');
          if (a.volume === 'vol_0') why.push('volume_start');
          break;
        case 'other_payments':
          if (prov) { rec = 'payments_mix'; why.push('mix'); if (prov !== 'prov_paypal') why.push('paypal'); }
          else { rec = 'payments_paypal'; why.push('paypal', 'card'); }
          if (a.volume === 'vol_3') why.push('volume_high');
          if (a.volume === 'vol_0') why.push('volume_start');
          break;
        case 'website':
          if (a.selling === 'sell_shopify') { rec = 'website_shopify'; why.push('website_shopify'); }
          else if (a.stage === 'stage_existing') { rec = 'website_redesign'; why.push('website_redesign'); }
          else { rec = 'website_new'; why.push('website_new'); }
          break;
        case 'app':
          if (a.selling === 'sell_no') { rec = 'app_mvp'; why.push('app_mvp'); }
          else { rec = 'app_store'; why.push('app_store'); }
          break;
        case 'automation':
          rec = 'automation'; why.push('automation');
          break;
        case 'custom':
          rec = 'custom'; why.push('custom');
          if (a.stage === 'stage_existing') why.push('website_redesign');
          break;
        default:
          break;
      }
      return { rec, why: [...new Set(why)] };
    }

    class CFConfigurator extends HTMLElement {
      connectedCallback() {
        if (!CF.firstBind(this)) return; // déplacement dans l'éditeur : écouteurs déjà posés sur ses enfants
        this.form = this.querySelector('form');
        this.t = CF.i18n(this.querySelector('script[data-cf-i18n]')) || { opt: {}, rec: {}, why: {} };
        this.qs = [...this.querySelectorAll('[data-q]')];
        this.out = {};
        this.querySelectorAll('[data-out]').forEach((n) => { this.out[n.getAttribute('data-out')] = n; });
        this.cta = this.querySelector('.cf-conf__cta');
        this.meter = [...this.querySelectorAll('.cf-conf__meter span')];
        this.started = false;
        this.completed = false;
        this.form.addEventListener('submit', (e) => e.preventDefault());
        this.form.addEventListener('change', () => {
          if (!this.started) { this.started = true; CF.track('configurator_start', {}, true); }
          this.update();
        });
        const pre = CF.quote.get();
        if (pre.service && !this.form.querySelector('input[name^="service-"]:checked')) {
          const r = this.form.querySelector(`input[name^="service-"][value="${pre.service}"]`);
          if (r) r.checked = true;
        }
        this.update();
        // questions en accordéons progressifs (une ouverte à la fois, résumé du choix, « Modifier »)
        this.acc = CF.accordion ? CF.accordion(this.form, '[data-q]', { edit: this.t.edit || 'Edit' }) : null;
        this.form.addEventListener('change', () => { if (this.acc) setTimeout(() => this.acc.refresh(), 220); });
      }

      answers() {
        const val = (q) => { const el = this.form.querySelector(`[data-q="${q}"] input:checked`); return el ? el.value : ''; };
        const vals = (q) => [...this.form.querySelectorAll(`[data-q="${q}"] input:checked`)].map((i) => i.value);
        const sel = this.form.querySelector('[data-q="provider"] select');
        return { service: val('service'), store: val('store'), volume: val('volume'), needs: vals('needs'), provider: sel ? sel.value : '', stage: val('stage'), selling: val('selling'), tools: vals('tools') };
      }

      update() {
        const a = this.answers();
        let shown = 0, answered = 0;
        this.qs.forEach((q) => {
          const show = q.getAttribute('data-show');
          const visible = !show || (a.service && show.split(' ').includes(a.service));
          q.hidden = !visible;
          if (visible && q.getAttribute('data-q') !== 'service') {
            shown += 1;
            if (q.querySelector('input:checked') || (q.querySelector('select') && q.querySelector('select').value !== 'prov_none')) answered += 1;
          }
        });
        const steps = this.meter.length;
        const level = !a.service ? 0 : 1 + Math.min(steps - 1, Math.round((answered / Math.max(1, shown)) * (steps - 1)));
        this.meter.forEach((m, i) => m.classList.toggle('is-on', i < level));

        const { rec, why } = recommend(a);
        const T = this.t;
        this.out.name.textContent = rec ? T.rec[rec] : T.empty;
        const tags = [];
        if (a.store) tags.push(T.opt[a.store]);
        if (a.volume) tags.push(T.opt[a.volume]);
        a.needs.forEach((n) => tags.push(T.opt[n]));
        if (a.provider && a.provider !== 'prov_none' && (a.service === 'sumup' || a.service === 'other_payments')) tags.push(T.opt[a.provider]);
        if (a.stage) tags.push(T.opt[a.stage]);
        if (a.selling) tags.push(T.opt[a.selling]);
        a.tools.forEach((n) => tags.push(T.opt[n]));
        this.out.needs.innerHTML = '';
        tags.filter(Boolean).forEach((txt) => { const li = document.createElement('li'); li.textContent = txt; this.out.needs.appendChild(li); });
        this.out['needs-wrap'].hidden = !tags.length;
        this.out.why.innerHTML = '';
        why.forEach((w) => {
          const li = document.createElement('li');
          li.innerHTML = '<svg class="cf-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5.5 12.5l4 4 9-9" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg><span></span>';
          li.querySelector('span').textContent = T.why[w] || '';
          this.out.why.appendChild(li);
        });
        this.out['why-wrap'].hidden = !why.length;

        if (this.cta) {
          this.cta.setAttribute('data-cf-quote', a.service || '');
          const summary = rec ? `${T.rec[rec]}${tags.length ? ' — ' + tags.filter(Boolean).join(', ') : ''}` : '';
          if (summary) this.cta.setAttribute('data-cf-quote-config', summary); else this.cta.removeAttribute('data-cf-quote-config');
        }
        if (rec && answered >= Math.min(2, shown) && !this.completed) {
          this.completed = true;
          CF.track('configurator_complete', { service: a.service, recommendation: rec });
        }
      }
    }
    customElements.define('cf-configurator', CFConfigurator);
  };
  if (window.CF) start(); else document.addEventListener('cf:ready', start, { once: true });
})();
